import { Component, inject } from '@angular/core';
import { VendorTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorTypeCreateDto,
  VendorTypeDto,
  VendorTypeExcelDownloadDto,
  VendorTypeUpdateDto,
} from '../proxy/controlling/dtos/vendor-type';
import { VENDORTYPE_CONFIG, VENDORTYPE_FIELDS } from './vendor-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vendor-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorTypeService, ConfirmationService],
  templateUrl: './vendor-type.html',
  styleUrl: './vendor-type.scss',
})
export class VendorType extends BaseCrudComponent<
  VendorTypeDto,
  VendorTypeCreateDto,
  VendorTypeUpdateDto,
  VendorTypeExcelDownloadDto
> {
  service = inject(VendorTypeService);
  config = VENDORTYPE_CONFIG;
  fields = VENDORTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorTypeDto): VendorTypeUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorType';
  }
}
